import React, { FC } from "react"
import { Space, Switch, Tooltip, Typography } from "antd"

const { Text } = Typography

export const AppMetierSwitch: FC<{
  id?: string,
  checked: boolean
  onChange?: () => void
  label: string
  checkedInnerLabel?: string
  uncheckedInnerLabel?: string
  disabled?: boolean
  toolTip?: string
  style?: React.CSSProperties
}> = ({
  id,
  checked,
  onChange,
  label,
  checkedInnerLabel,
  uncheckedInnerLabel,
  disabled = false,
  toolTip,
  style
}) => (
  <Space direction={"horizontal"} style={style}>
    <Tooltip title={toolTip ? toolTip : undefined}>
      <span style={{ display: "inline-block" }}>
        <Switch
          id={id}
          size="small"
          checked={checked}
          onChange={onChange}
          disabled={disabled}
          checkedChildren={checkedInnerLabel}
          unCheckedChildren={uncheckedInnerLabel}
        />
      </span>
    </Tooltip>
    <Text>{label}</Text>
  </Space>
)
